import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { sortBy } from 'lodash'

import EventCards from '../../../components/grid/EventCards'
import getFilteredEventsForDateRange from '../../../utilities/events/getFilteredEventsForDateRange'

import '../../../styles/scss/components/grid/grid.scss'

const GridContainer = ({ view }) => {
  const startDate = useSelector((state) => state.filtersData.startDate)
  const endDate = useSelector((state) => state.filtersData.endDate)
  const activeCategories = useSelector((state) => state.filtersData.categories)
  const activeLocations = useSelector((state) => state.filtersData.locations)
  const eventsData = useSelector((state) => state.eventsData)
  const [activeStartDate, setActiveStartDate] = useState(moment(startDate))
  const [activeEndDate, setActiveEndDate] = useState(
    endDate && endDate !== '' ? moment(endDate) : null
  )

  useEffect(() => {
    setActiveStartDate(moment(startDate))
  }, [startDate])
  useEffect(() => {
    setActiveEndDate(endDate && endDate !== '' ? moment(endDate) : null)
  }, [endDate])

  const filteredEvents = getFilteredEventsForDateRange(
    eventsData,
    activeCategories,
    activeLocations,
    activeStartDate,
    activeEndDate
  )
  const sortedEvents = sortBy(filteredEvents, function (evt) {
    return new moment(evt.activeDates.startDate)
  })

  return (
    <div className="decoupled-events__grid">
      <EventCards events={sortedEvents} />
    </div>
  )
}

export default GridContainer
